import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from '../../../../_services/localStorage/local-storage.service';
import { ProjectResourcesService } from '../../../../_services/projectResources/project-resources.service';
import { CommonModule, DatePipe } from '@angular/common';
import { ChartModule, CategoryService, StackingColumnSeriesService, TooltipService, LegendService, AccumulationChartModule, AccumulationLegendService, AccumulationTooltipService, PieSeriesService, AccumulationDataLabelService, AccumulationAnnotationService } from '@syncfusion/ej2-angular-charts';
import { ProjectService } from '../../../../_services/project/project.service';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { convertYYYYMMDDtoDDMMYYYY } from '../../../../_helpers/utils';
import { ActivatedRoute, Router } from '@angular/router';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';

@Component({
  selector: 'pmoDashboard',
  templateUrl: './pmoDashboard.component.html',
  styleUrls: ['./pmoDashboard.component.scss'],
  providers: [ChartModule, CategoryService, TooltipService, StackingColumnSeriesService, LegendService, AccumulationChartModule, CommonModule, AccumulationLegendService, AccumulationTooltipService, PieSeriesService, AccumulationDataLabelService, AccumulationAnnotationService],
})
export class PMODashboard implements OnInit {

  // ── Inner Tab ─────────────────────────────────────────────────────────────────
  activeInnerTab: string = 'hour-utilization';

  // ── Shared ───────────────────────────────────────────────────────────────────
  projectForm: FormGroup;
  bookedHoursForm: FormGroup;
  currentUser: any;
  tenantId: any;
  selectedProject: any;
  startDate: any;
  endDate: any;
  TodayDate: any;
  date: any;
  isAdministrator: boolean = false;
  projectDropdownList: any[] = [];

  // ── Hour Utilization: Hour Estimation Charts ──────────────────────────────────
  public chartData: any[] = [];
  public chartData1: any[] = [];
  public chartData2: any[] = [];
  dataLabel: any;
  dataLabel1: any;
  dataLabel2: any;
  currentMonth: any;
  currentYear: any;
  public centerText: string = '';
  public centerText1: string = '';
  public centerText2: string = '';
  totalYearly = 0;
  totalMonthly = 0;

  // ── Hour Utilization: Booked Hours Chart ──────────────────────────────────────
  totalBookedHours: any;
  bookedHoursData: any[] = [];
  title = 'Total Booked Hours(Approved)';
  tooltip = { enable: true };
  primaryXAxis = { valueType: 'Category', labelIntersectAction: 'Rotate45' };
  primaryYAxis = { minimum: 0, title: 'Booked Hours(Approved)' };

  // ── Hour Utilization: Project Efficiency Chart ────────────────────────────────
  projectEfficiencyData: any[] = [];
  title1 = 'Project Efficiency';
  primaryXAxis1 = { valueType: 'Category', labelIntersectAction: 'Rotate45' };
  primaryYAxis1 = { minimum: 0, title: 'Efficiency' };

  // ── Hour Utilization: Free Resources ─────────────────────────────────────────
  public freeResources: any;
  public freeResourcesV2: any;

  public legendSettings: Object = { visible: true };
  public data: Object[];

  // ── Project Summary: Designation Pie Chart ────────────────────────────────────
  public designationData: object[] = [];
  public datalabel?: Object;

  // ── Project Summary: Ag-Grids ─────────────────────────────────────────────────
  public columnDefs1: ColDef[] = [];
  public columnDefs2: ColDef[] = [];
  rowData1: any;
  rowData2: any;
  private api: GridApi;
  private columnApi: ColumnApi;
  defaultColDef: any;

  // ── Project Summary: Risk Matrix ──────────────────────────────────────────────
  riskManagementOption: any;
  public riskManagement = [
    [0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0]
  ];

  constructor(
    private formBuilder: FormBuilder,
    private storageService: LocalStorageService,
    private projectResourcesServices: ProjectResourcesService,
    private projectService: ProjectService,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
  ) {
    this.data = [];
    this.bookedHoursForm = this.formBuilder.group({
      startDate: new FormControl(''),
      endDate: new FormControl('')
    });
    this.projectForm = this.formBuilder.group({
      project: new FormControl('')
    });
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    const currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.currentUser = currentUser;
    this.isAdministrator = this.currentUser.roles.includes('RoleAdministrator');

    this.selectedProject = this.route.snapshot.queryParamMap.get('projectID');
    if (this.selectedProject) {
      this.getProjectById(this.selectedProject);
    }
    this.getProjectsData();

    // Date defaults for booked hours
    this.date = new Date();
    this.TodayDate = this.datePipe.transform(this.date, 'yyyy-MM-dd');
    this.endDate = this.TodayDate;
    this.date.setDate(this.date.getDate() - 30);
    this.startDate = this.datePipe.transform(this.date, 'yyyy-MM-dd');
    this.bookedHoursForm.patchValue({ startDate: this.startDate, endDate: this.endDate });
    this.getTotalBookedHours();
  }

  // ── V1 Project List ───────────────────────────────────────────────────────────

  getProjectsData(): void {
    this.projectDropdownList = [];
    if (this.isAdministrator) {
      this.projectService.getProjects().subscribe((response: any) => {
        for (let item of response) {
          this.projectDropdownList.push(`${item.id} . ${item.projectName}`);
        }
      });
    } else {
      this.projectService.getProjectByUserId(this.currentUser.id, false).subscribe((response: any) => {
        for (let item of response) {
          this.projectDropdownList.push(`${item.id} . ${item.projectName}`);
        }
      });
    }
  }

  getProjectById(projectId: any): void {
    this.projectService.getProject(projectId).subscribe((response: any) => {
      let project = projectId + ' . ' + response.projectName;
      this.projectForm.patchValue({ project: project });
      this.loadAllProjectData(projectId);
    });
  }

  fetchProjectDetails(event: any): void {
    const selectedProjectId = event.target.value.split(' . ')[0];
    this.selectedProject = selectedProjectId;
    this.loadAllProjectData(selectedProjectId);
  }

  private loadAllProjectData(projectId: any): void {
    this.getProjectEstimations(projectId);
    this.getProjectTaskEstimations(projectId);
    this.getProjectTasksCompletionReport(projectId);
    this.getOverdueProjectTasks(projectId);
    this.getProjectRiskManagements(projectId);
    this.getProjectCriticalRisk(projectId);
  }

  // ── Hour Utilization Methods ──────────────────────────────────────────────────

  getProjectEstimations(projectId: any): void {
    let year: number = 2026;
    let month: number = 4;
    this.projectResourcesServices.getProjectEstimations(projectId, year, month).subscribe((data: any) => {
      this.centerText1 = `YEARLY: ${data.year}`;
      this.centerText2 = `Monthly:<br/>${data.month} ${data.year}`;
      this.totalYearly = data.yearly.totalHours;
      this.totalMonthly = data.monthly.totalHours;
      this.chartData1 = [
        { x: 'Remaining Hours', y: data.yearly.totalHours - data.yearly.approvedHours, z: data.yearly.totalHours },
        { x: 'Approved Hours', y: data.yearly.approvedHours, z: data.yearly.totalHours }
      ];
      this.chartData2 = [
        { x: 'Remaining Hours', y: data.monthly.totalHours - data.monthly.approvedHours, z: data.monthly.totalHours },
        { x: 'Approved Hours', y: data.monthly.approvedHours, z: data.monthly.totalHours }
      ];
      this.dataLabel1 = { visible: true, position: 'Inside', name: 'text', font: { fontWeight: '400', color: '#fff', size: '14px' } };
      this.dataLabel2 = { visible: true, position: 'Inside', name: 'text', font: { fontWeight: '400', color: '#fff', size: '14px' } };
    });
  }

  getProjectTaskEstimations(projectId: any): void {
    this.projectResourcesServices.getProjectTaskEstimations(projectId).subscribe((data: any) => {
      this.chartData = [
        { x: 'Open Task', y: data.openTasks },
        { x: 'Closed Task', y: data.closedTasks }
      ];
      this.centerText = `
        <div style="color: black; background-color: #4A73C8; padding: 10px 20px; border-radius: 10px; font-weight: bold; font-size: 16px;">
          YEARLY: ${data.year}
        </div>`;
      this.dataLabel = { visible: true, position: 'Inside', name: 'text', font: { fontWeight: '400', color: '#fff', size: '14px' } };
    });
  }

  public getChartAnnotation(centerText: string): any[] {
    return [{
      content: `<div style="text-align:center;font-size:16px;font-weight:bold;padding:10px;">${centerText}</div>`,
      region: 'Chart', x: '50%', y: '50%'
    }];
  }

  onTooltipRender(event: any): void {
    const data = this.data;
    const data2 = event.data;
    let data3;
    data.forEach(p => {
      if (p['xName'] === data2['pointX'] && p['yName'] === data2['pointY']) { data3 = p; }
    });
    if (data3) { event.text = `${data3.seriesName}: ${data3.yName} Hrs\nTotal: ${data3.z} Hrs`; }
  }

  getTotalBookedHours(): void {
    let start = this.bookedHoursForm.get('startDate')?.value;
    start = convertYYYYMMDDtoDDMMYYYY(start);
    let end = this.bookedHoursForm.get('endDate')?.value;
    end = convertYYYYMMDDtoDDMMYYYY(end);

    if (start === '' || end === '') {
      window.alert('Please Select Both StartDate and EndDate');
    } else {
      this.getProjectEfficiencyReport(start, end);
      this.getProjectFreeResourceReport(start, end);
      // this.getProjectFreeResourceReportV2(start, end);
      this.projectResourcesServices.getProjectHoursBookingReport(start, end).subscribe((response: any) => {
        this.bookedHoursData = response.projectBookedHoursElementMedia.map((item: any) => ({
          xName: item.projectName.trim(), yName: item.bookedHours
        }));
        this.totalBookedHours = response.totalBookedHours;
      });
    }
  }

  getProjectEfficiencyReport(start: any, end: any): void {
    this.projectResourcesServices.getProjectEfficiencyReport(start, end).subscribe((response: any) => {
      this.projectEfficiencyData = response.projectEfficiencyReportElementMedia.map((item: any) => ({
        xName: item.projectName.trim(), yName: item.projectEfficiency
      }));
    });
  }

  getProjectFreeResourceReport(start: any, end: any): void {
    this.projectResourcesServices.getProjectFreeResourceReport(start, end).subscribe((response: any) => {
      if (response && Object.keys(response).length > 0) { this.freeResources = response; }
    });
  }

  // getProjectFreeResourceReportV2(start: any, end: any): void {
  //   this.projectResourcesServices.getProjectFreeResourceReportV2(start, end).subscribe((response: any) => {
  //     if (response && Object.keys(response).length > 0) { this.freeResourcesV2 = response; }
  //   });
  // }

  // ── Project Summary Methods ───────────────────────────────────────────────────

  onGridReady(params: any): void {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }

  getProjectTasksCompletionReport(projectId: any): void {
    this.projectService.getProjectTasksCompletionReport(projectId).subscribe((response: any) => {
      let designationData = [];
      for (let key of Object.keys(response)) { designationData.push({ name: key, value: response[key] }); }
      this.designationData = designationData;
    });
  }

  getOverdueProjectTasks(projectId: any): void {
    this.columnDefs1 = [
      { headerName: 'Task Name', field: 'name' },
      { headerName: 'Start Date', field: 'startDate' },
      { headerName: 'End Date', field: 'endDate' },
      { headerName: 'Task Owner Name', field: 'taskOwnerName' },
    ];
    this.projectService.getOverdueProjectTasks(projectId).subscribe((response: any) => {
      this.rowData1 = response;
    });
  }

  getProjectRiskManagements(projectId: any): void {
    this.riskManagement = [[0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0]];
    this.projectService.getProjectRiskManagements(projectId).subscribe((response: any) => {
      this.riskManagementOption = response.result;
      for (let x = 0; x < this.riskManagementOption.length; x++) {
        let sev = this.riskManagementOption[x]['severity'];
        let prob = this.riskManagementOption[x]['probability'];
        if (sev == 'Low' && prob == 'Very Probable(>50%)') { this.riskManagement[0][0]++; }
        if (sev == 'Low' && prob == 'Probable(<50%)') { this.riskManagement[0][1]++; }
        if (sev == 'Low' && prob == 'Perhaps(<10%)') { this.riskManagement[0][2]++; }
        if (sev == 'Low' && prob == 'Improbably(<5%)') { this.riskManagement[0][3]++; }
        if (sev == 'Moderate' && prob == 'Very Probable(>50%)') { this.riskManagement[1][0]++; }
        if (sev == 'Moderate' && prob == 'Probable(<50%)') { this.riskManagement[1][1]++; }
        if (sev == 'Moderate' && prob == 'Perhaps(<10%)') { this.riskManagement[1][2]++; }
        if (sev == 'Moderate' && prob == 'Improbably(<5%)') { this.riskManagement[1][3]++; }
        if (sev == 'High' && prob == 'Very Probable(>50%)') { this.riskManagement[2][0]++; }
        if (sev == 'High' && prob == 'Probable(<50%)') { this.riskManagement[2][1]++; }
        if (sev == 'High' && prob == 'Perhaps(<10%)') { this.riskManagement[2][2]++; }
        if (sev == 'High' && prob == 'Improbably(<5%)') { this.riskManagement[2][3]++; }
        if (sev == 'Catastropic' && prob == 'Very Probable(>50%)') { this.riskManagement[3][0]++; }
        if (sev == 'Catastropic' && prob == 'Probable(<50%)') { this.riskManagement[3][1]++; }
        if (sev == 'Catastropic' && prob == 'Perhaps(<10%)') { this.riskManagement[3][2]++; }
        if (sev == 'Catastropic' && prob == 'Improbably(<5%)') { this.riskManagement[3][3]++; }
      }
    });
  }

  getProjectCriticalRisk(projectId: any): void {
    this.columnDefs2 = [
      { headerName: 'Evaluation', field: 'evaluation' },
      { headerName: 'Status', field: 'status' },
      { headerName: 'Date Found', field: 'DateFound' },
      { headerName: 'Highest Impact On', field: 'highestImpactOn' },
      { headerName: 'Probability', field: 'probability' },
      { headerName: 'Description', field: 'description' },
    ];
    this.projectService.getProjectCriticalRisk(projectId).subscribe((response: any) => {
      this.rowData2 = response.result;
    });
  }
}
